module.exports = __webpack_public_path__ + "static/img/thumb-num-invasive.4bca1da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumb-num-invasive.png
// module id = 93
// module chunks = 0